module.exports = __webpack_public_path__ + "img/generated-park.d4a90ef1.png";